export function buildAuthenticatedWebSocketUrl(baseUrl: string, token?: string): string {
    if (!baseUrl) {
        return '';
    }
    if (!token) {
        return '';
    }

    try {
        const url = new URL(baseUrl);
        url.searchParams.set('token', token);
        return url.toString();
    } catch {
        const separator = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${separator}token=${encodeURIComponent(token)}`;
    }
}
